import React, { useState } from 'react';

const SUPABASE_URL = 'https://lmdwjmayitewvgfmfdmu.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxtZHdqbWF5aXRld3ZnZm1mZG11Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE3ODI3NzIsImV4cCI6MjA4NzM1ODc3Mn0.6-eMa62rGiu99iy5TAVRttJcFi0XnuKHnHKfQnlMJro';

export default function Login({ onLoginSuccess }) {
  const [locationId, setLocationId] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin() {
    const id = locationId.trim();
    if (!id) {
      setError('Please enter your Location ID.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch(
        `${SUPABASE_URL}/rest/v1/transactions?select=location_id&location_id=eq.${encodeURIComponent(id)}&limit=1`,
        {
          headers: {
            'apikey': SUPABASE_KEY,
            'Authorization': `Bearer ${SUPABASE_KEY}`
          }
        }
      );
      const data = await res.json();

      if (!data || data.length === 0) {
        setError('Location ID not found. Please check your ID and try again.');
        return;
      }

      onLoginSuccess(id);
    } catch (err) {
      setError('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') handleLogin();
  }

  return (
    <div style={styles.body}>
      <div style={styles.grid} />
      <div style={styles.wrap}>
        <div style={styles.brandLabel}>Rent Flow Solutions</div>
        <h1 style={styles.h1}>
          FLEET <span style={styles.accent}>DASHBOARD</span>
        </h1>
        <div style={styles.subtitle}>Sign in to view your fleet</div>

        <div style={styles.card}>
          <div style={styles.cardBar} />

          {error && <div style={styles.errorMsg}>{error}</div>}

          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Location ID</label>
            <input
              type="text"
              value={locationId}
              onChange={e => setLocationId(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="e.g. Ngu5ILmSMx87bHuGGQLW"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              style={styles.input}
            />
            <div style={styles.hint}>
              Your Location ID can be found in your Rent Flow Solutions account settings.
            </div>
          </div>

          <button
            onClick={handleLogin}
            disabled={loading}
            style={{ ...styles.btn, opacity: loading ? 0.5 : 1 }}
          >
            {loading ? 'Verifying...' : 'Access Fleet Dashboard'}
          </button>
        </div>

        <div style={styles.footerNote}>
          Your data is private and tied to your location only.<br />
          Need help? Contact Rent Flow Solutions support.
        </div>
      </div>
    </div>
  );
}

const styles = {
  body: {
    background: '#0a0c0f',
    color: '#e8eaf0',
    fontFamily: "'DM Sans', sans-serif",
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  grid: {
    position: 'fixed',
    inset: 0,
    backgroundImage: 'linear-gradient(#1e232d 1px, transparent 1px), linear-gradient(90deg, #1e232d 1px, transparent 1px)',
    backgroundSize: '40px 40px',
    opacity: 0.4,
    pointerEvents: 'none',
    zIndex: 0,
  },
  wrap: {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    maxWidth: 420,
    padding: 20,
    textAlign: 'center',
  },
  brandLabel: {
    fontFamily: "'DM Mono', monospace",
    fontSize: 10,
    color: '#00e5a0',
    letterSpacing: '0.2em',
    textTransform: 'uppercase',
    marginBottom: 6,
  },
  h1: {
    fontFamily: "'Bebas Neue', sans-serif",
    fontSize: 38,
    letterSpacing: '0.05em',
    lineHeight: 1,
    marginBottom: 6,
    color: '#e8eaf0',
  },
  accent: {
    color: '#00e5a0',
  },
  subtitle: {
    fontFamily: "'DM Mono', monospace",
    fontSize: 11,
    color: '#5a6478',
    marginBottom: 36,
    letterSpacing: '0.05em',
  },
  card: {
    background: '#111318',
    border: '1px solid #1e232d',
    borderRadius: 12,
    padding: 32,
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'left',
  },
  cardBar: {
    position: 'absolute',
    top: 0, left: 0, right: 0,
    height: 2,
    background: 'linear-gradient(90deg, #00e5a0, #0066ff)',
  },
  errorMsg: {
    background: '#ff475712',
    border: '1px solid #ff475730',
    borderRadius: 6,
    padding: '10px 14px',
    fontFamily: "'DM Mono', monospace",
    fontSize: 11,
    color: '#ff4757',
    marginBottom: 16,
  },
  formGroup: {
    marginBottom: 20,
  },
  formLabel: {
    fontFamily: "'DM Mono', monospace",
    fontSize: 10,
    color: '#5a6478',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    display: 'block',
    marginBottom: 8,
  },
  input: {
    width: '100%',
    background: '#181c23',
    border: '1px solid #1e232d',
    color: '#e8eaf0',
    fontFamily: "'DM Mono', monospace",
    fontSize: 13,
    padding: '12px 14px',
    borderRadius: 8,
    outline: 'none',
    letterSpacing: '0.03em',
    boxSizing: 'border-box',
  },
  hint: {
    fontFamily: "'DM Mono', monospace",
    fontSize: 10,
    color: '#5a6478',
    marginTop: 7,
    lineHeight: 1.5,
  },
  btn: {
    width: '100%',
    background: '#00e5a0',
    color: '#000',
    border: 'none',
    fontFamily: "'DM Mono', monospace",
    fontSize: 13,
    fontWeight: 500,
    padding: 13,
    borderRadius: 8,
    cursor: 'pointer',
    letterSpacing: '0.05em',
  },
  footerNote: {
    fontFamily: "'DM Mono', monospace",
    fontSize: 10,
    color: '#5a6478',
    marginTop: 20,
    lineHeight: 1.6,
  },
};
